import React from "react";
import { ContentLayout, HeaderBreadcrumbs } from "../../../shared";
import { SalesVatReportFilterSection } from "../components";
import { useSalesVatReport } from "../hooks";

export const SalesVatReportPage = () => {
  const {
    state,
    errors,
    handlers,
    isStoreAdmin,
    storeOptions,
    maxMonth,
  } = useSalesVatReport();

  const breadcrumbs = [
    { name: "Dashboard", href: isStoreAdmin ? "/store-admin" : "/" },
    { name: "Tax Reports" },
  ];

  return (
    <ContentLayout
      title="Tax Reports"
      breadcrumbs={<HeaderBreadcrumbs links={breadcrumbs} />}
      borderBottom="none"
    >
      <SalesVatReportFilterSection
        values={state.filter}
        errors={errors}
        maxMonth={maxMonth}
        storeOptions={isStoreAdmin ? null : storeOptions}
        isExporting={state.isExporting}
        onMonthChange={handlers.handleMonthChange}
        onStoreChange={handlers.handleStoreChange}
        onGenerate={handlers.handleGenerate}
      />
    </ContentLayout>
  );
};
